
function Footer() {
    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark mt-5 px-3">
            <span className="navbar-text">AMD-Project WS21/22 - Robert Schulz, Lucas Schmutzler</span>
        </nav>
    )
}

export default Footer;